<section *ngIf="vm$ | async as vm" fxFlex class="material-story w-100" fxLayout="column" fxLayoutAlign="center stretch">
    <app-hero-title fxFlex fxHide.lt-sm="true" class="" [title]="vm?.details?.title"></app-hero-title>
    <div ngClass.sm="sm" ngClass.xs="xs" ngClass.gt-sm="xl" fxFlex class="help-content" fxLayout="row" fxLayoutAlign="center center">
        <div class="help-html" fxFlex fxFlex.gt-sm="70" [innerHTML]="vm?.details?.content | safe : 'html'"></div>
    </div>
</section>
